/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartTrendXyUpIcon24Solid = forwardRef('DataChartTrendXyUpIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M4.125 3a1.125 1.125 0 0 0-2.25 0v15A4.125 4.125 0 0 0 6 22.125h16a1.125 1.125 0 0 0 0-2.25H6A1.875 1.875 0 0 1 4.125 18V3Z" }),
        React.createElement("path", { d: "M22.082 7.707a1 1 0 0 0-1.414-1.414L15 11.96l-2.502-2.502a1.5 1.5 0 0 0-2.121 0l-3.584 3.584a1 1 0 1 0 1.414 1.414l3.23-3.23 2.502 2.502a1.5 1.5 0 0 0 2.122 0l6.021-6.022Z" })));
});
